import ElementClassHandler from './utils/element-class-handler.js';
import Selectors from './utils/selectors.js';
import FormValidator from './form-validator';

const formValidator = new FormValidator(),
    elementClassHandler = new ElementClassHandler;

export default class ExistingNumber {
    constructor(options = {}) {
        this.dataIdentifier = options.dataIdentifier || 'data-existing-number-id';
        this.dataOptionsIdentifier = options.dataOptionsIdentifier || 'data-existing-number-options';
        this.selectors = new Selectors({
            dataAttrId: this.dataIdentifier
        });
        this.existingNumberIdentifier = options.existingNumberIdentifier || 'form_existingNetworkDetails_';
        this.fieldType = options.fieldType || 'radio';
        this.existingNumberFields = this.selectors.querySelectorArray(this.selectors.attrSelector(this.dataIdentifier));
        this.options = JSON.parse(document.querySelector(this.selectors.attrSelector(this.dataOptionsIdentifier)).value);
        this.networkMarketingPreferencesContainer = document.querySelector('[data-network-marketing-preferences-container]');
        this.networkIdentifierField = document.querySelector('[data-existing-number-id]');
    }

    setup() {
        if (this.existingNumberFields.length) {
            this.setDefaultView();
            this.setupFormListener();
        }
    }

    toggleRequired(existingNumberId, existing) {
        let existingNumberField = document.querySelector('#' + this.existingNumberIdentifier + existingNumberId),
            existingNumberFieldRow = document.querySelector('#' + this.existingNumberIdentifier + existingNumberId + '_row');
        if (existing == 1) {
            this.enableMarketingPreference();
            existingNumberField.setAttribute('required', 'required');
            formValidator.removeValidationClasses(existingNumberField);
            if (existingNumberField.value) {
                formValidator.validateField(existingNumberField);
            }
            elementClassHandler.show(existingNumberFieldRow);
        } else {
            this.disableMarketingPreference();
            existingNumberField.removeAttribute('required');
            existingNumberField.value = '';
            formValidator.validateField(existingNumberField);
            elementClassHandler.hide(existingNumberFieldRow);
        }
    }

    setDefaultView() {
        let self = this;
        this.existingNumberFields.forEach(function(el) {
            let existingNumberId = self.getExistingNumberId(el),
                status = self.options[existingNumberId];
            if (status !== 'order') {
                return;
            }
            let errorField = el.querySelector('[data-existing-number-error]');
            elementClassHandler.hide(errorField);
            let existingFieldChoice = el.querySelector('input:checked');
            if (!existingFieldChoice || existingFieldChoice.value == 0) {
                self.toggleRequired(existingNumberId, 0);
            }
            if (!existingFieldChoice) {
                document.querySelector('.form-submit').addEventListener('click', (e) => {
                    let existingFieldChoice = el.querySelector('input:checked');
                    if (existingFieldChoice) {
                        return true;
                    }
                    e.preventDefault();
                    elementClassHandler.show(errorField);
                    return false;
                });
            }
        });
    }

    setupFormListener() {
        let self = this;
        this.existingNumberFields.forEach(function(elem) {
            let existingNumberId = self.getExistingNumberId(elem);
            let status = self.options[existingNumberId];
            if (status === 'upgrade') {
                self.toggleRequired(existingNumberId, 1);
                return;
            }
            let existingFieldChoices = self.selectors.querySelectorArray('input' + self.selectors.attrSelector('type', self.fieldType), elem);
            existingFieldChoices.forEach(function(el) {
                el.addEventListener('change', (e) => {
                    let errorField = elem.querySelector('[data-existing-number-error]');
                    elementClassHandler.hide(errorField);
                    e.preventDefault();
                    self.toggleRequired(existingNumberId, el.value);
                });
            });
        });
    }

    getExistingNumberId(element) {
        return element.getAttribute(this.dataIdentifier);
    }

    enableMarketingPreference() {
        if (!this.networkMarketingPreferencesContainer || this.getExistingNumberId(this.networkIdentifierField) != 'eeNumber') {
            return;
        }
        this.networkMarketingPreferencesContainer.removeAttribute('hidden');

        this.networkMarketingPreferencesContainer.querySelectorAll('input').forEach(function(input) {
            input.removeAttribute('disabled');
        });
    }

    disableMarketingPreference() {
        if (!this.networkMarketingPreferencesContainer || this.getExistingNumberId(this.networkIdentifierField) != 'eeNumber') {
            return;
        }
        this.networkMarketingPreferencesContainer.setAttribute('hidden', 'hidden');
        this.networkMarketingPreferencesContainer.querySelectorAll('input').forEach(function(input) {
            input.setAttribute('disabled', 'disabled');
        });
    }
}
